import fetch from '../../utils/fetch'

export function getUserTicketHistory(params) {
    return fetch({
        url: '/api/ticket/wxUserTicketList',
        method: 'POST',
        data: params
    })
}

export function getUserTicketDetails(id) {
    return fetch({
        url: '/api/ticket/wxUserTicketInfo/' + id,
        method: 'GET'
    })
}
